import React from 'react';
import { Check, Text, Warning } from '@myinterview/component-library';
import { IColors } from '@myinterview/component-library/dist/interfaces/variables';
import { useTranslation } from 'react-i18next';
import {
  ICameraStateKey, IChecksState, IInternetStateKey, IMicrophoneStateKey,
} from '../interfaces/widgetInterface';
import { Loading } from './icons/Loading';

interface IProps {
  checksState: IChecksState;
  checksMessages: { camera: string; microphone: string; internet: string; }
  canRetrySpeedTest: boolean;
  onRetry: () => void;
  recordWithoutVideo?:boolean;
}

type IIconStateValue = { el: JSX.Element, color: IColors };

const ICON_BY_CAMERA_STATE: { [K in ICameraStateKey]: IIconStateValue } = {
  WAITING: { el: <Loading />, color: 'neutral-20' },
  ERROR: { el: <Warning />, color: 'error' },
  READY: { el: <Check />, color: 'success' },
  SKIP: { el: <Warning />, color: 'success' },
};

const ICON_BY_MICROPHONE_STATE: { [K in IMicrophoneStateKey]: IIconStateValue } = {
  WAITING: { el: <Loading />, color: 'neutral-20' },
  ERROR: { el: <Warning />, color: 'error' },
  READY: { el: <Check />, color: 'success' },
};

const ICON_BY_INTERNET_STATE: { [K in IInternetStateKey]: IIconStateValue } = {
  DISCONNECTED: { el: <Warning />, color: 'error' },
  TESTING: { el: <Loading />, color: 'neutral-20' },
  SLOW_CONNECTION: { el: <Warning />, color: 'success' },
  CONNECTED: { el: <Check />, color: 'success' },
};

export const SetupChecks:React.FC<IProps> = ({
  checksState, checksMessages, canRetrySpeedTest, onRetry, recordWithoutVideo,
}) => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget-checks">
      {!recordWithoutVideo && (
      <div className="myinterview-widget-checks__item">
        <div className={`myinterview-widget-checks__icon color--${ICON_BY_CAMERA_STATE[checksState.camera].color}`}>
          {ICON_BY_CAMERA_STATE[checksState.camera].el}
        </div>
        <div className="myinterview-widget-checks__text-wrapper">
          <Text>{t('setup.camera.name')}</Text>
          <Text color="neutral-50">{t(checksMessages.camera)}</Text>
        </div>
      </div>
      )}
      <div className="myinterview-widget-checks__item">
        <div className={`myinterview-widget-checks__icon color--${ICON_BY_MICROPHONE_STATE[checksState.microphone].color}`}>
          {ICON_BY_MICROPHONE_STATE[checksState.microphone].el}
        </div>
        <div className="myinterview-widget-checks__text-wrapper">
          <Text>{t('setup.microphone.name')}</Text>
          <Text color="neutral-50">
            {t(checksMessages.microphone)}
          </Text>
        </div>
      </div>
      <div className="myinterview-widget-checks__item">
        <div className={`myinterview-widget-checks__icon color--${ICON_BY_INTERNET_STATE[checksState.internet].color}`}>
          {ICON_BY_INTERNET_STATE[checksState.internet].el}
        </div>
        <div className="myinterview-widget-checks__text-wrapper">
          <Text>{t('setup.internet.name')}</Text>
          <Text color="neutral-50">
            {t(checksMessages.internet)}
            {canRetrySpeedTest && (
            <button className="myinterview-widget-checks__retry" onClick={onRetry} type="button">
              {t('buttons.btn_internet_test_again')}
            </button>
            )}
          </Text>
        </div>
      </div>
    </div>
  );
};
